import styled from 'styled-components';

export const ViewRoot = styled.div<{ $active: boolean }>`
  flex: 1;
  display: ${({ $active }) => ($active ? 'flex' : 'none')};
  overflow: hidden;
`;

export const BoardOv = styled.div`
  flex: 1;
  overflow: auto;
  padding: 20px 30px 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #f4f7f8;
  background-image:
    radial-gradient(
      140% 70% at 22% -8%,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(255, 255, 255, 0) 55%
    ),
    radial-gradient(
      120% 50% at 92% 108%,
      rgba(120, 140, 150, 0.12) 0%,
      transparent 55%
    ),
    linear-gradient(157deg, #fbfdfe 0%, #f1f5f6 55%, #e9eef0 100%);

  &::before {
    content: '';
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    opacity: 0.04;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.012 0.04' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='512' height='512' filter='url(%23n)'/%3E%3C/svg%3E");
    background-size: 300px 300px;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -10%;
    width: 55%;
    height: 100%;
    pointer-events: none;
    z-index: 0;
    background: linear-gradient(
      118deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 42%
    );
    transform: skewX(-8deg);
    filter: blur(8px);
  }

  & > * {
    position: relative;
    z-index: 1;
  }

  &::-webkit-scrollbar-track {
    background: #dfe5e8;
  }
  &::-webkit-scrollbar-thumb {
    background: #8a939b;
    border: 3px solid transparent;
    background-clip: padding-box;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #5a6066;
    background-clip: padding-box;
  }
  scrollbar-color: #8a939b #dfe5e8;
`;

export const SectionLabel = styled.div`
  display: inline-block;
  color: #2e333a;
  margin-bottom: 4px;
  font-family: var(--head);
  font-weight: 700;
  font-size: 30px;
  line-height: 1.08;
`;
